<div *ngIf="page=='confirmation' " class="modal-dialog modal-xl modal-content">
    <div class="modal-header">
        <div><h2 class="modal-title" >Caution !!!</h2></div>
    </div>
    <div class="modal-body">
        <div>{{data['text']}}</div>
    </div>
    <hr>
    <div class="modal-footer" style="margin-top: 5px;">
        <button type="button" class="button-secondary-small left-side" (click)="onClose()">Close</button>
        <button type="button" class="button-validate-small" (click)="validateAction()">Continue</button>
    </div>
</div>

<div *ngIf="page=='upload_content' " class="modal-dialog modal-xl modal-content">
    <div class="modal-header">
        <div><h2 class="modal-title" >Caution !!!</h2></div>
    </div>
    <div class="modal-body">
        <div>{{data['text']}}</div>
    </div>
    <div fxLayout="row" fxLayout.xs="column">
        <div fxFlex="50" style="padding: 20px;">
            <div fxLayout="row">
                <div class="label-style" fxFlex="30">Supplier</div>
                <div fxFlex="70">
                    <mat-select [formControl]="supplierControl" placeholder="Supplier" (selectionChange)="switchNewSupplier($event.value)">
                        <input class="col-input-filter" [formControl]="supplierSearchControl">
                        <mat-select-trigger>{{ supplierSelected?.full_name || 'Create new supplier'}}</mat-select-trigger>
                        <mat-option [value] = 0>Create new supplier</mat-option>
                        <mat-option *ngFor="let user of suppliers" [value]="user.id">
                            <span class="option-user"><span class="avatar small-avatar" [style.background]="user.color || '#016F86'">{{ user.initials }}</span><span><strong>{{ user.full_name }}</strong><small>{{ user.email }} · {{ user.phone }}</small></span></span>
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="separator"></div>
            <div fxLayout="row">
                <div class="label-style" fxFlex="30">Wave</div>
                <div fxFlex="70">
                    <mat-select placeholder="Set Wave" [formControl]="waveControl">
                        <mat-option [value]="">Choose</mat-option>
                        <mat-option [value]="result['id']" *ngFor="let result of userWaves; let i = index">{{result['name_fr']}} {{yearWave}}</mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="separator"></div>
            <div fxLayout="row">
                <div class="label-style" fxFlex="30">Description</div>
                <div fxFlex="70">
                    <input type="text" class="col-input" [formControl]="supplierDescriptionControl"  placeholder="Supplier Description" value="">
                </div>
            </div>
        </div>
        <div *ngIf="isNewSupplier" fxFlex="50" style="padding: 20px;">
            <div fxLayout="row">
                <div class="label-style" fxFlex="30">Name</div>
                <div fxFlex="70">
                    <input type="text" class="col-input" [formControl]="supplierNameControl"  placeholder="Supplier Name" value="">
                </div>
            </div>
            <div class="separator"></div>
            <div fxLayout="row">
                <div class="label-style" fxFlex="30">Phone</div>
                <div fxFlex="70">
                    <input type="tel" class="col-input" [formControl]="phoneControl" (input)="onPhoneInput($event)" placeholder="Phone" style="margin: 0;">
                </div>
            </div>
            <div class="separator"></div>
            <div fxLayout="row">
                <div class="label-style" fxFlex="30">Acquisition Amount</div>
                <div fxFlex="70">
                    <input class="col-input" [formControl]="contentAcquisitionControl" type="number" min="0" step="0.01" placeholder="Ex. 200,00 FCFA">
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="modal-footer" style="margin-top: 5px;">
        <button type="button" class="button-secondary-small left-side" (click)="onClose()">Close</button>
        <button type="button" class="button-validate-small" (click)="sendUploadValidation()">Continue</button>
    </div>
</div>

<div *ngIf="page=='new_project' " class="modal-dialog modal-xl modal-content">
    <div class="modal-header">
        <div><h2 class="modal-title" >Create new Project</h2></div>
    </div>
    <div fxLayout="row" fxLayout.xs="column" style="padding-top: 10px;">
        <div class="label-style" fxFlex="40">Project Name</div>
        <div class="separator"></div>
        <div class="class-mat-field" fxFlex="60">
            <input type="text" class="col-input" [formControl]="projectNameControl" placeholder="Project name">
        </div>
    </div>
    <hr>
    <div class="modal-footer" style="margin-top: 5px;">
        <button type="button" class="button-secondary-small left-side" (click)="closeProjectCreation()">Close</button>
        <button type="button" class="button-validate-small" (click)="sendProjectName()">Continue</button>
    </div>
</div>

<div *ngIf="page=='video_show' " class="modal-dialog modal-xl modal-content">
    <div class="modal-header">
        <div><h2 class="modal-title" >{{data['title']}}</h2></div>
    </div>
    <div id="demo_container" class="modal-dialog modal-xl modal-content" >
        <video controls preload="metadata" style="width: 100%; height: 50%" loop autoplay>
          <source src="{{data['url']}}">video can't play
        </video>
    </div>
    <hr>
</div>






